import { z } from 'zod'
import { TagSchema } from './tag'

export const ConfigSchema = z.object({
  supportEmail: z.string(),
  tags: TagSchema.array(),
})

export type Config = z.infer<typeof ConfigSchema>
